module.exports = __webpack_public_path__ + "static/media/logo_appsilon_color.0a8d9fc9.svg";